import { MDText } from 'i18n-react';

import { TextCTA } from '../../TextCTA/TextCTA';
import biddingSectionCTAStateControllerTexts from '../BiddingSectionCTAStateController.texts';

const kycLocalT = new MDText(biddingSectionCTAStateControllerTexts.placeBidKycAfterSubmit);

export const PlaceBidKycAfterSubmit: React.FC = () => (
	<TextCTA description={`${kycLocalT.translate('description')}`} title={`${kycLocalT.translate('title')}`} />
);
